export const container = `
  cursor-pointer
  relative
  h-7 w-5
  text-white
  group
`;

export const background = `
  h-7
  w-5
  cursor-pointer
  fill-ll-primary
  stroke-ll-primary
  stroke-1
  box-border
  transition-all
  group-hover:stroke-white
  group-focus:stroke-white
`;

export const icon = `
  absolute
  top-0 left-0 right-0 bottom-0
  m-auto
  mt-1.5
  h-3 w-3
`;
